interface InvoiceCancelationCodeWrapper {
    enum: InvoiceCancelationCodeEnum
    description: string
}

interface InvoiceCancelationWithCancelationCode {
    cancelationCode: InvoiceCancelationCodeEnum
}

export enum InvoiceCancelationCodeEnum {
    EMISSION_ERR = 1,
    SERVICE_NOT_EXECUTED = 2,
    DOCUMENT_DUPLICITY = 4,
}

export class InvoiceCancelationModel {
    static getInvoiceCancelationCodeWrappedList():InvoiceCancelationCodeWrapper[] {
        return [
            {
                enum: InvoiceCancelationCodeEnum.EMISSION_ERR,
                description: 'Erro na emissão',
            },
            {
                enum: InvoiceCancelationCodeEnum.SERVICE_NOT_EXECUTED,
                description: 'Serviço não prestado',
            },
            {
                enum: InvoiceCancelationCodeEnum.DOCUMENT_DUPLICITY,
                description: 'Duplicidade de nota',
            },
        ]   
    }

    cancelationCodeWrapper:InvoiceCancelationCodeWrapper = {
        enum: InvoiceCancelationCodeEnum.EMISSION_ERR,
        description: 'Erro na emissão'
    }

    cancelationCode:InvoiceCancelationCodeEnum = InvoiceCancelationCodeEnum.EMISSION_ERR

    constructor(i?:Partial<InvoiceCancelationModel>) {
        Object.assign(this, i)
    }

    isValid():boolean {
        return !!this.cancelationCodeWrapper?.enum && !!this.cancelationCode
    }

    getInformationNormalized():InvoiceCancelationWithCancelationCode {
        return {
            cancelationCode: this.cancelationCodeWrapper?.enum,
        }
    }
}
